import hoist from 'hoist-non-react-statics';
import React, { Component } from 'react';
import { setGridBreakpoints } from '../../SetGridBreakpoints';
import getDisplayName from '../../../../utils/getDisplayName';

function setDisabled({ isMobileBreakpoint, disabled, ignoredElement }) {
    if (!isMobileBreakpoint()) {
        return;
    }

    const inputs = document.getElementsByTagName('input');
    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i] !== ignoredElement) {
            inputs[i].disabled = disabled;
        }
    }
}

export function disableAllInputs() {
    return WrappedComponent => {
        @setGridBreakpoints()
        class DisableAllInputs extends Component {
            static displayName = `DisableAllInputs(${getDisplayName(WrappedComponent)})`;
            static WrappedComponent = WrappedComponent;

            render() {
                const {
                    isMobileBreakpoint,
                } = this.props;

                return (
                    <WrappedComponent
                        setDisabled={({ disabled, ignoredElement }) =>
                            setDisabled({
                                disabled,
                                isMobileBreakpoint,
                                ignoredElement,
                            })
                        }
                        {...this.props}
                    />
                );
            }
        }

        hoist(DisableAllInputs, WrappedComponent);

        return DisableAllInputs;
    };
}
